export const caseNames: { [key: string]: Array<string> } = {
  "1c/1c": ["1c/1c"],
  "3c/3c": ["3c/3c"],
  "cadj/cadj": ["cadj/cadj"],
  "good tent/tent": ["right tent/right tent", "left tent/left tent"],
  "bad tent/tent": ["right tent/left tent", "left tent/right tent"],
  "good tent/whale": [
    "right tent/left whale",
    "left tent/right whale",
    "right whale/left tent",
    "left whale/right tent",
  ],
  "bad tent/whale": [
    "right tent/right whale",
    "left tent/left whale",
    "right whale/right tent",
    "left whale/left tent",
  ],
  "good whale/whale": ["right whale/right whale", "left whale/left whale"],
  "bad whale/whale": ["right whale/left whale", "left whale/right whale"],
  "gem/gem": ["gem/gem"],
  "gem/squid": ["squid/gem", "gem/squid"],
  "gem/axe": ["gem/right axe", "gem/left axe", "right axe/gem", "left axe/gem"],
  "gem/knight": [
    "gem/right knight",
    "gem/left knight",
    "right knight/gem",
    "left knight/gem",
  ],
  "good knight/axe": [
    "right knight/right axe",
    "right axe/right knight",
    "left knight/left axe",
    "left axe/left knight",
  ],
  "bad knight/axe": [
    "right knight/left axe",
    "right axe/left knight",
    "left knight/right axe",
    "left axe/right knight",
  ],
  "same knight/knight": [
    "left knight/left knight",
    "right knight/right knight",
  ],
  "opp knight/knight": ["left knight/right knight", "right knight/left knight"],
  "same axe/axe": ["left axe/left axe", "right axe/right axe"],
  "opp axe/axe": ["left axe/right axe", "right axe/left axe"],
  "squid/squid": ["squid/squid"],
  "squid/axe": [
    "squid/right axe",
    "squid/left axe",
    "right axe/squid",
    "left axe/squid",
  ],
  "squid/knight": [
    "squid/right knight",
    "squid/left knight",
    "right knight/squid",
    "left knight/squid",
  ],
  "good bunny/bunny": ["right bunny/right bunny", "left bunny/left bunny"],
  "bad bunny/bunny": ["right bunny/left bunny", "left bunny/right bunny"],
  "good bunny/thumb": [
    "right bunny/right thumb",
    "left bunny/left thumb",
    "right thumb/right bunny",
    "left thumb/left bunny",
  ],
  "bad bunny/thumb": [
    "right bunny/left thumb",
    "left bunny/right thumb",
    "right thumb/left bunny",
    "left thumb/right bunny",
  ],
  "good thumb/thumb": ["right thumb/right thumb", "left thumb/left thumb"],
  "bad thumb/thumb": ["right thumb/left thumb", "left thumb/right thumb"],
  "cadj/copp": ["cadj/copp", "copp/cadj"],
  "good bird/yoshi": [
    "left bird/right yoshi",
    "left yoshi/right bird",
    "right bird/left yoshi",
    "right yoshi/left bird",
  ],
  "bad bird/yoshi": [
    "left bird/left yoshi",
    "left yoshi/left bird",
    "right bird/right yoshi",
    "right yoshi/right bird",
  ],
  "hazard/yoshi": [
    "hazard/right yoshi",
    "hazard/left yoshi",
    "left yoshi/hazard",
    "right yoshi/hazard",
  ],
  "shell/yoshi": [
    "shell/right yoshi",
    "shell/left yoshi",
    "left yoshi/shell",
    "right yoshi/shell",
  ],
  "kite/tie": [
    "left kite/tie",
    "right kite/tie",
    "tie/right kite",
    "tie/left kite",
    "left kite/tie2",
    "right kite/tie2",
    "tie2/right kite",
    "tie2/left kite",
  ],
  "good kite/pinwheel": [
    "left kite/left pinwheel",
    "right kite/right pinwheel",
    "right pinwheel/right kite",
    "left pinwheel/left kite",
  ],
  "bad kite/pinwheel": [
    "left kite/right pinwheel",
    "right kite/left pinwheel",
    "right pinwheel/left kite",
    "left pinwheel/right kite",
  ],
  "tree/pinwheel": [
    "tree/right pinwheel",
    "tree/left pinwheel",
    "right pinwheel/tree",
    "left pinwheel/tree",
    "tree2/right pinwheel",
    "tree2/left pinwheel",
    "right pinwheel/tree2",
    "left pinwheel/tree2",
  ],
  "good tree/tie": ["tree2/tie", "tie/tree2", "tie2/tree", "tree/tie2"],
  "bad tree/tie": ["tree/tie", "tie/tree", "tie2/tree2", "tree2/tie2"],
  "cut/tie": [
    "left cut/tie",
    "right cut/tie",
    "tie/left cut",
    "tie/right cut",
    "left cut/tie2",
    "right cut/tie2",
    "tie2/left cut",
    "tie2/right cut",
  ],
  "good cut/pinwheel": [
    "left cut/left pinwheel",
    "right cut/right pinwheel",
    "left pinwheel/left cut",
    "right pinwheel/right cut",
  ],
  "bad cut/pinwheel": [
    "left cut/right pinwheel",
    "right cut/left pinwheel",
    "left pinwheel/right cut",
    "right pinwheel/left cut",
  ],
  "good kite/cut": [
    "right kite/left cut",
    "left cut/right kite",
    "right cut/left kite",
    "left kite/right cut",
  ],
  "bad kite/cut": [
    "right kite/right cut",
    "right cut/right kite",
    "left cut/left kite",
    "left kite/left cut",
  ],
  "good t/t": ["tree/tree2", "tree2/tree"],
  "bad t/t": ["tree/tree", "tree2/tree2"],
  "good cut/cut": ["right cut/right cut", "left cut/left cut"],
  "bad cut/cut": ["left cut/right cut", "right cut/left cut"],
  "good tie/tie": ["tie/tie2", "tie2/tie"],
  "bad tie/tie": ["tie/tie", "tie2/tie2"],
  "shell/shell": ["shell/shell"],
  "shell/bird": [
    "shell/right bird",
    "shell/left bird",
    "right bird/shell",
    "left bird/shell",
  ],
  "shell/hazard": ["shell/hazard", "hazard/shell"],
  "good bird/bird": ["left bird/right bird", "right bird/left bird"],
  "bad bird/bird": ["left bird/left bird", "right bird/right bird"],
  "bird/hazard": [
    "left bird/hazard",
    "right bird/hazard",
    "hazard/left bird",
    "hazard/right bird",
  ],
  "kite/t": [
    "right kite/tree",
    "right kite/tree2",
    "left kite/tree",
    "left kite/tree2",
    "tree/right kite",
    "tree2/right kite",
    "tree/left kite",
    "tree2/left kite",
  ],
  "cut/t": [
    "tree/right cut",
    "right cut/tree",
    "tree2/right cut",
    "right cut/tree2",
    "tree/left cut",
    "left cut/tree",
    "tree2/left cut",
    "left cut/tree2",
  ],
  "yoshi/yoshi": [
    "right yoshi/right yoshi",
    "right yoshi/left yoshi",
    "left yoshi/right yoshi",
    "left yoshi/left yoshi",
  ],
  "good kite/kite": ["left kite/left kite", "right kite/right kite"],
  "bad kite/kite": ["left kite/right kite", "right kite/left kite"],
  "hazard/hazard": ["hazard/hazard"],
  "tie/n": [
    "tie/left pinwheel",
    "left pinwheel/tie",
    "tie/right pinwheel",
    "right pinwheel/tie",
    "tie2/left pinwheel",
    "left pinwheel/tie2",
    "tie2/right pinwheel",
    "right pinwheel/tie2",
  ],
  "good n/n": ["left pinwheel/left pinwheel", "right pinwheel/right pinwheel"],
  "bad n/n": ["left pinwheel/right pinwheel", "right pinwheel/left pinwheel"],
  "copp/copp": ["copp/copp"],
};
